(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["0-how-it-works"] && !Shopify.designMode) return;
  try {
    
const initScrollingHowItWorks = () => {
  if (window.innerWidth >= 750) {
    ScrollTrigger.getAll().forEach(t => t.kill());

    const stepTextWraps = document.querySelectorAll(".step_text-block");
    stepTextWraps.forEach((wrap) => {
      gsap.set(wrap, { backgroundColor: "var(--cream)" });

      ScrollTrigger.create({
        trigger: wrap,
        start: "top 50%",
        end: "bottom 50%",
        onEnter: () => gsap.to(wrap, { backgroundColor: "var(--neon)", duration: 1, ease: "power3.out" }),
        onLeaveBack: () => gsap.to(wrap, { backgroundColor: "var(--cream)", duration: 1, ease: "power3.out" }),
      });
    });

    const step1 = document.querySelector(".step.step-1");
    const step2 = document.querySelector(".step.step-2");
    const step3 = document.querySelector(".step.step-3");
    const step1Img1 = document.querySelector(".step-1_img-1");
    const step1Img2 = document.querySelector(".step-1_img-2");
    const step1Img3 = document.querySelector(".step-1_img-3");
    if (!step1 || !step2 || !step3 || !step1Img1 || !step1Img2 || !step1Img3) return;

    gsap.set([step1, step2, step1Img1, step1Img2, step1Img3], { y: 0 });

    const getDelta = () => step3.offsetTop - step2.offsetTop;

    // STEP 1
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: step1,
        start: "top 20%",
        end: "bottom 20%",
        scrub: 1,
        invalidateOnRefresh: true,
      },
      defaults: { ease: "none" },
    });

    tl.to(step1, { y: "20rem" }, 0);
    tl.to(step1Img1, { y: "-5rem" }, 0);
    tl.to(step1Img2, { y: "-10rem" }, 0);
    tl.to(step1Img3, { y: "-15rem" }, 0);

    // STEP 2
    ScrollTrigger.create({
      trigger: step2,
      start: "top 20%",
      end: () => `+=${getDelta()}`,
      scrub: 1,
      invalidateOnRefresh: true,
      onRefresh: () => {
        // kill any existing phase-2 timeline on refresh and rebuild below
        if (step2._joinTl) step2._joinTl.kill();
        step2._joinTl = buildJoinTimeline();
      },
      onEnter: () => {
        // build once if it doesn't exist yet
        if (!step2._joinTl) step2._joinTl = buildJoinTimeline();
      },
    });

    function buildJoinTimeline() {
      const currentStep1Y = gsap.getProperty(step1, "y") || 0;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: step2,
          start: "top 20%",
          end: () => `+=${getDelta()}`,
          scrub: 1,
          invalidateOnRefresh: true,
        },
        defaults: { ease: "none" },
      });

      tl.set(step1, { y: currentStep1Y }, 0);
      tl.to(step2, { y: () => `+=${getDelta()}` }, 0);

      return tl;
    }
  }
};

const handleLoad = () => {
  if (window.innerWidth >= 750) {
    initScrollingHowItWorks();
  }
};

const handleResize = () => {
  if (window.innerWidth >= 750) {
    ScrollTrigger.refresh();
    initScrollingHowItWorks();
  } else {
    ScrollTrigger.getAll().forEach(t => t.kill());
  }
};

window.addEventListener("load", handleLoad);
window.addEventListener("resize", handleResize);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
